import iaxios from "./iaxios";

// All partner-portal endpoints + the regular user login.
//
// The Go backend dropped the legacy node `/api/partner/*` surface. Partners
// now log in through the regular user endpoint (`/api/user/login` — partners
// are users with `IsPartner=true`) and read self-service data from the new
// `/api/partner/**` portal endpoints. The legacy login still returns a token
// accepted via the `x-access-token` header (CombinedAuthMiddleware on the
// backend), so we keep that header here for minimal churn.

const authHeader = () => ({
  "x-access-token": localStorage.getItem("token"),
});

// ----------------------------------------------------------------------------
// Auth.
// ----------------------------------------------------------------------------

// Login — backed by `POST /api/partner/login`, which on the Go backend is
// just an alias of the regular user legacy login handler. Same request/
// response shape as /user/login. The is-partner gate is enforced
// downstream by the /api/partner/** portal endpoints (403 if not).
export function loginPartner(email, password) {
  return iaxios.post("/partner/login", { email, password });
}

// ----------------------------------------------------------------------------
// Identity.
// ----------------------------------------------------------------------------

// Regular user /me — returns firstName, lastName, email, etc.
export function getUser() {
  return iaxios.get("/user/me", { headers: authHeader() });
}

// Partner self-projection — totals (total_earned, total_paid) live here, not
// on the user document.
export function getPartnerMe() {
  return iaxios.get("/partner/me", { headers: authHeader() });
}

// ----------------------------------------------------------------------------
// Content + stats.
// ----------------------------------------------------------------------------

// Per-film hit/cash/part stats for the authenticated partner.
export function getPartnerFilms(page = 1, take = 20) {
  return iaxios.get(`/partner/stats/films?page=${page}&take=${take}`, {
    headers: authHeader(),
  });
}

// Per-series hit/cash/part stats for the authenticated partner.
export function getPartnerSeries(page = 1, take = 20) {
  return iaxios.get(`/partner/stats/series?page=${page}&take=${take}`, {
    headers: authHeader(),
  });
}

// Public legacy endpoint — list seasons for one series. Used to drive the
// series → seasons → episode-stats navigation. Returns a raw JSON array.
export function getSeriesSeasons(seriesId) {
  return iaxios.get(`/season/getall/${seriesId}`);
}

// Per-episode stats inside one season for the authenticated partner.
export function getPartnerEpisodes(seasonId, page = 1, take = 50) {
  return iaxios.get(
    `/partner/stats/episodes?season_id=${seasonId}&page=${page}&take=${take}`,
    { headers: authHeader() }
  );
}

// ----------------------------------------------------------------------------
// Payouts.
// ----------------------------------------------------------------------------

export function getPartnerPayments(page = 1, take = 8) {
  return iaxios.get(`/partner/payouts?page=${page}&take=${take}`, {
    headers: authHeader(),
  });
}
